import React, { useState, useEffect } from "react";
import demoPic from "/img/profile-pic.jpg"; // fallback picture
import secureLocalStorage from "react-secure-storage";
import axios from "axios";

const PictureSection = ({ currentPictureUrl, onUpdate }) => {
  const [preview, setPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Default: use current user picture or demo
    setPreview(currentPictureUrl || demoPic);
  }, [currentPictureUrl]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreview(URL.createObjectURL(file)); // instant preview
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) return alert("Please select a picture first.");
    setLoading(true);

    try {
      const payload = new FormData();
      payload.append("picture", selectedFile);
      payload.append("userId", import.meta.env.VITE_API_USER);
      payload.append("password", import.meta.env.VITE_API_PASS);
	  payload.append("user", secureLocalStorage.getItem("user"));
	  payload.append("token", secureLocalStorage.getItem("token"));
      // Send to your API endpoint
      const res = await axios.post(
        `${import.meta.env.VITE_API_BASE_URL}/update-picture`,
        payload,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
		const code = res?.data?.responseCode?.toString();	
		if (code === "200") {
			alert("Profile picture updated successfully!");
			onUpdate(res?.data?.picture || preview);
			secureLocalStorage.setItem("picture", res?.data?.picture);
		} else {		
			alert(res?.data?.responseMsg  || "Failed to update picture.");
		}
    } catch (error) {
      console.error("Error uploading picture:", error);
      alert("Error uploading picture. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm p-5 border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-700 mb-4">
        Profile Picture
      </h3>

      <div className="flex items-center gap-6">
        {/* Picture Preview */}
        <div className="relative">
          <img
            src={`${import.meta.env.VITE_API_SOURCE_URL}${preview}`}
            alt="Profile"
            className="w-32 h-32 rounded-full border-4 border-blue-600 object-cover shadow-md transition-all duration-300 hover:scale-105"
          />
          {loading && (
            <div className="absolute inset-0 bg-white/60 flex items-center justify-center rounded-full">
              <span className="text-blue-600 font-semibold text-sm animate-pulse">
                Uploading...
              </span>
            </div>
          )}
        </div>

        {/* Upload Controls */}
        <div className="flex flex-col gap-3">
          <label className="text-sm text-gray-600 font-medium">
            Choose a new picture
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="text-sm border rounded-lg p-2 focus:ring-2 focus:ring-blue-500 transition-all duration-200"
          />
          <button
            onClick={handleUpload}
            disabled={loading}
            className={`px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 transition-all duration-200 w-fit ${
              loading ? "opacity-70 cursor-not-allowed" : ""
            }`}
          >
            {loading ? "Updating..." : "Update Picture"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PictureSection;

